import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { DeviationGraphChannel, ExhaustGraphChannel } from '@models/graphs';
import { DeviceFlagsService } from '@service/device-flags.service';
import { Channel } from 'ops/common/models/channel';
import { ExhaustChannel, ExhaustGraph, TurboChargerChannel } from 'ops/common/models/graphs';

@Component({
    selector: 'app-exhaust-graph',
    templateUrl: './exhaust-graph.component.html',
    styleUrls: ['./exhaust-graph.component.css'],
    standalone: false
})
export class ExhaustGraphComponent implements OnChanges {
    @ViewChild('cylinder') cylinder!: ElementRef;
    @ViewChild('deviation') deviation!: ElementRef;
    @ViewChild('turbo') turbo!: ElementRef;

    @Input() channels: { [key: string | number]: Channel };
    @Input() graph: ExhaustGraph;
    @Input() title: string;

    cylinderChannels: ExhaustGraphChannel[] = [];
    turboChannels: ExhaustGraphChannel[] = [];
    deviationChannels: DeviationGraphChannel[] = [];
    averageChannel: number = 0;

    constructor(
        private flagService: DeviceFlagsService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.graph) {
            this.updateGraphChannels();
        }
    }

    ngOnInit() {
        this.updateGraphChannels();
        this.flagService.onAllFlagsUpdated().subscribe(() => {
            this.updateGraphChannels();
            this.cdr.detectChanges();
        });
    }

    updateGraphChannels() {
        this.createCyliderChannels();
        this.createDevaitionChannels();
        this.createTurboChargerChannels();

        if (this.channels[this.graph.averageChannel]) {
            this.averageChannel = this.getChannelValue(this.channels[this.graph.averageChannel]);
        }
    }

    createCyliderChannels() {
        let cylinderChannels = [];

        if (this.graph.exhaustChannels) {
            for (let i = 0; i < this.graph?.exhaustChannels.length; i++) {
                cylinderChannels[i] = this.getExhaustGraphChannel(this.graph.exhaustChannels[i]);
            }
        }

        this.cylinderChannels = cylinderChannels;
    }

    createDevaitionChannels() {
        let deviationChannels = [];
        if (this.graph.exhaustChannels) {
            for (let i = 0; i < this.graph.exhaustChannels.length; i++) {
                deviationChannels[i] = this.getExhaustDeviationGraphChannel(
                    this.graph.exhaustChannels[i],
                );
            }
        }

        this.deviationChannels = deviationChannels;
    }

    createTurboChargerChannels() {
        let turboChannels = [];
        if (this.graph.turboChargerChannels) {
            for (let i = 0; i < this.graph.turboChargerChannels.length; i++) {
                turboChannels[i] = this.getExhaustGraphChannel(this.graph.turboChargerChannels[i]);
            }
        }
        this.turboChannels = turboChannels;
    }

    getExhaustGraphChannel(graphChannel: ExhaustChannel | TurboChargerChannel) {
        return {
            channel: this.channels[graphChannel.fcuChannelId],
            title: graphChannel.title,
            value: this.getChannelValue(this.channels[graphChannel.fcuChannelId])
                ? this.getChannelValue(this.channels[graphChannel.fcuChannelId])
                : 0,
        };
    }

    getExhaustDeviationGraphChannel(graph: ExhaustChannel) {
        return {
            channel: this.channels[graph.deviationChannel],
            title: graph.title,
            value: this.getChannelValue(this.channels[graph.deviationChannel])
                ? this.getChannelValue(this.channels[graph.deviationChannel])
                : 0,
            temperatureChannel: this.channels[graph.fcuChannelId],
        };
    }

    getChannelValue(channel: Channel) {
        return this.flagService.getFlags(channel)?.value;
    }
}
